import {Dropdown} from "react-bootstrap";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import {Link, useNavigate} from "react-router-dom";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import ImageComponent from "../../components/shared/ImageComponent";
import StarIcon from "../../../images/icons/starIcon";
import NoProfile from "../../../images/profileImage.png";
import CategoryIcon from "../../../images/icons/CategoryIcon";
import NoImage from "../../../images/NoImage.jpg";
import {interventionDate, proposalDate} from "../../../utils/date";
import {
  getInterventionStatusColor,
  getInterventionStatusLabel,
} from "../../../utils/status";
import {interventionStatus} from "../../../utils/constants";
import {getInterventionPath} from "../../../utils/interventionUrl";

export const InterventionCardTech = ({intervention, categories, chatroom}) => {
  const subCatgegory = intervention?.Offer_Proposal?.Offer?.SubCategories[0];
  const category = categories?.find((el) => el.id == subCatgegory?.fatherId);

  const {Offer_Proposal, startDate, title} = intervention || {};
  const client = Offer_Proposal?.Offer?.Client?.User;
  const navigate = useNavigate();
  const {bg, color} = getInterventionStatusColor({
    status: intervention?.status,
  });
  const statusLabel = getInterventionStatusLabel(intervention);

  return (
    <div
      className="w-full  flex flex-col overflow-hidden bg-white  rounded-2xl border border-solid border-[#E2E2E2] cursor-pointer"
      onClick={() => {
        navigate(getInterventionPath(intervention));
      }}
    >
      <div
        className={`w-full p-6 flex flex-col gap-2  relative 
        `}
      >
        {/* <div className=" !px-6 !py-3 gap-5  absolute top-0 right-0 flex justify-end items-center ">
          <Dropdown>
            <DropdownToggle
              variant=""
              className=" i-false !p-0 font-bold text-lg "
            >
              <i className="fi fi-rr-menu-dots-vertical flex items-center"></i>{" "}
            </DropdownToggle>
            <DropdownMenu align="right" className="mt-2 w-[150px] p-0 ">
              <div className="cursor-pointer dropdown-item group    !px-4 border-b font-semibold hover:bg-[#EFF2F7]">
                <Link
                  to={getInterventionPath(intervention)}
                  className="  text-[#3D4465] hover:text-[#3D4465] text-sm"
                >
                  Voir
                </Link>
              </div>
            </DropdownMenu>
          </Dropdown>
        </div> */}
        <div className="flex items-center justify-between  flex-wrap-reverse">
          <div className="flex items-start justify-start gap-3 ">
            <Link
              onClick={(e) => {
                e.stopPropagation();
              }}
              to={"/client/" + intervention?.Offer_Proposal?.Offer?.Client?.id}
              className="relative min-w-11 w-11"
            >
              {!!intervention?.Offer_Proposal?.Offer?.Client?.User
                ?.avgRating && (
                <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
                  {Number(
                    intervention?.Offer_Proposal?.Offer?.Client?.User
                      ?.avgRating,
                  ).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-2 h-2" />
                </div>
              )}
              <ImageComponent
                src={buildImageUrl(
                  intervention?.Offer_Proposal?.Offer?.Client?.User?.imageUri,
                )}
                alt=""
                className=" w-11 h-11 min-w-11 rounded-full object-cover"
                fallback={
                  <img
                    src={NoProfile}
                    alt=""
                    className=" w-11 h-11 min-w-11 rounded-full object-cover"
                    width="130"
                  />
                }
              />
            </Link>
            <div className="flex flex-col justify-center items-start">
              <Link
                title={
                  intervention?.Offer_Proposal?.Offer?.Client?.User?.lastName +
                  " " +
                  intervention?.Offer_Proposal?.Offer?.Client?.User?.firstName
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
                to={
                  "/client/" + intervention?.Offer_Proposal?.Offer?.Client?.id
                }
                className="text-[#19295C] font-bold text-sm sm:text-base truncate capitalize"
              >
                {intervention?.Offer_Proposal?.Offer?.Client?.User?.lastName +
                  " " +
                  intervention?.Offer_Proposal?.Offer?.Client?.User?.firstName}
              </Link>
              <div className="flex items-center justify-start gap-2 flex-wrap ">
                <div className="text-dark flex flex-nowrap gap-2 text-xs sm:text-[14px] text-nowrap mr-[10px]">
                  <i className="fi fi-rr-calendar flex items-center"></i>
                  {proposalDate(intervention?.startDate)}
                </div>
              </div>
            </div>
          </div>
          <div className="flex justify-end w-full sm:w-fit">
            <div
              style={{
                backgroundColor: bg,
                color: color,
              }}
              className={`flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold `}
            >
              <div
                style={{
                  backgroundColor: color,
                }}
                className={`w-2 h-2 rounded-full `}
              ></div>
              <span className="text-nowrap">{statusLabel}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center  ">
          <div className="text-[#FF6600] text-base text-nowrap  ">
            <i className="fi fi-rr-coins flex items-center"></i>
          </div>
          <div className=" text-[#FF6600]  ml-1 font-semibold text-xs sm:text-[16px] flex items-center gap-1 text-nowrap ">
            {intervention?.Offer_Proposal?.initialBudget}€
            {!!intervention?.additionalPrice && (
              <>
                <span>+{intervention?.additionalPrice}€</span>
                <span className="text-xs">(frais supplémentaire)</span>
              </>
            )}
          </div>
        </div>

        <div className="text-base sm:text-lg flex items-center justify-start  font-medium mt-2  w-full ">
          <Link
            onClick={(e) => {
              e.stopPropagation();
            }}
            title={intervention?.title}
            to={getInterventionPath(intervention)}
            className="text-[#19295C]  font-semibold text-[18px]  capitalize-first text-wrap  "
          >
            {intervention?.title}
          </Link>
        </div>

        <div className="flex w-full justify-start items-center flex-wrap gap-4">
          {!!intervention?.Offer_Proposal?.Offer && (
            <>
              <div className="bg-[#F1F2F7] rounded-md   flex !px-[12px] !py-[5px] gap-2 justify-center items-center text-sm font-semibold text-[#19295C]">
                <ImageComponent
                  src={buildImageUrl(category?.Sector?.imagePath)}
                  alt="secteur"
                  title={category?.Sector?.title}
                  className=" w-4 aspect-square"
                  fallback={
                    <img
                      src={NoImage}
                      alt=""
                      className=" w-4 aspect-square"
                      width="130"
                      title={category?.Sector?.title}
                    />
                  }
                />
                <span>{category?.Sector?.title}</span>
              </div>
              <div className="flex justify-start items-center gap-2  text-[#7E7E7E] font-bold text-[15px]">
                <CategoryIcon className="w-4 h-4 fill-[#1A64B9]" />{" "}
                {category?.title ?? "--"}
              </div>
            </>
          )}
        </div>
      </div>
      {![interventionStatus.CANCELED, interventionStatus.ENDED].includes(
        intervention?.status,
      ) && (
        <div className="w-full border-t border-solid border-[#E2E2E2] grid grid-cols-3 ">
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            href={`tel:${client?.phone}`}
            className="flex items-center justify-center gap-2 p-3 text-[#0022AA] font-semibold text-xl hover:text-[#0022AA] hover:bg-[#f5f7fa]"
          >
            <i className="fi fi-rr-phone-call flex items-center"></i>
            <span className="text-base hidden sm:inline-block">Appel</span>
          </a>
          <Link
            onClick={(e) => {
              e.stopPropagation();
            }}
            to={`/messages#${chatroom?.id}`}
            className=" border-l border-solid border-[#E2E2E2] flex items-center justify-center gap-2 p-3 text-[#FF6600] hover:bg-[#f5f7fa] font-semibold text-xl"
          >
            <i className="fi fi-rr-comment-dots flex items-center"></i>
            <span className="text-base hidden sm:inline-block">Messages</span>
          </Link>
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            target="_blank"
            rel="noopener noreferrer"
            href={`http://maps.google.com/?q=${Offer_Proposal?.Offer?.address} ${Offer_Proposal?.Offer?.ville} ${Offer_Proposal?.Offer?.postCode}`}
            className=" border-l border-solid border-[#E2E2E2] flex items-center justify-center gap-2 p-3 text-[#1A64B9] font-semibold text-xl hover:text-[#1A64B9] hover:bg-[#f5f7fa] "
          >
            <i className="fi fi-rr-land-location flex items-center"></i>{" "}
            <span className="text-base hidden sm:inline-block">Itinéraire</span>
          </a>
        </div>
      )}
    </div>
  );
};

export const InterventionCardTechDirect = ({
  intervention,
  categories,
  chatroom,
}) => {
  const {bg, color} = getInterventionStatusColor({
    status: intervention?.status,
  });
  const statusLabel = getInterventionStatusLabel(intervention);
  const {Offer_Proposal, startDate, title} = intervention || {};
  const client = Offer_Proposal?.directChat?.chatroom?.Client?.User;
  const navigate = useNavigate();

  return (
    <div
      className="w-full  flex flex-col overflow-hidden bg-white  rounded-2xl border border-solid border-[#E2E2E2] cursor-pointer"
      onClick={() => {
        navigate(getInterventionPath(intervention));
      }}
    >
      <div
        className={`w-full p-6 flex flex-col gap-2  relative 
        `}
      >
        <div className="flex items-center justify-between  flex-wrap-reverse">
          <div className="flex items-start justify-start gap-3 ">
            <Link
              to={"/client/" + client?.id}
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="relative min-w-11 w-11"
            >
              <div className="bg-[#FFC107] w-[30px] flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[7px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] ">
                {Number(client?.avgRating).toFixed(2)}
                <StarIcon className="fill-white stroke-none w-2 h-2" />
              </div>
              <ImageComponent
                src={buildImageUrl(client?.imageUri)}
                alt=""
                className=" w-11 h-11 min-w-11 rounded-full object-cover"
                fallback={
                  <img
                    src={NoProfile}
                    alt=""
                    className=" w-11 h-11 min-w-11 rounded-full object-cover"
                    width="130"
                  />
                }
              />
            </Link>
            <div className="flex flex-col justify-center items-start">
              <Link
                title={client?.firstName + " " + client?.lastName}
                to={"/client/" + client?.id}
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="text-[#19295C] font-bold text-sm sm:text-base truncate capitalize"
              >
                {client?.firstName + " " + client?.lastName}
              </Link>
              <div className="flex items-center justify-start gap-2 flex-wrap ">
                <div className="text-dark flex flex-nowrap gap-2 text-xs sm:text-[14px] text-nowrap mr-[10px]">
                  <i className="fi fi-rr-calendar flex items-center"></i>
                  {proposalDate(intervention?.startDate)}
                </div>
              </div>
            </div>
          </div>

          <div className="flex justify-end w-full sm:w-fit">
            <div
              style={{
                backgroundColor: bg,
                color: color,
              }}
              className={`flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold `}
            >
              <div
                style={{
                  backgroundColor: color,
                }}
                className={`w-2 h-2 rounded-full `}
              ></div>
              <span className="text-nowrap">{statusLabel}</span>
            </div>
          </div>
        </div>
        <div className="flex items-center ">
          <div className="text-[#FF6600] text-base text-nowrap  ">
            <i className="fi fi-rr-coins flex items-center"></i>
          </div>
          <div className=" text-[#FF6600] ml-1 font-semibold text-xs sm:text-[16px] flex items-center gap-1 text-nowrap ">
            {intervention?.Offer_Proposal?.initialBudget}€
            {!!intervention?.additionalPrice && (
              <>
                <span>+{intervention?.additionalPrice}€</span>
                <span className="text-xs">(frais supplémentaire)</span>
              </>
            )}
          </div>
        </div>
        <div className="text-lg flex items-center justify-start max-w-[70%]  font-medium mt-2  w-full ">
          <Link
            onClick={(e) => {
              e.stopPropagation();
            }}
            title={intervention?.title}
            to={getInterventionPath(intervention)}
            className="text-[#19295C]  font-semibold text-[18px]  capitalize-first text-wrap  "
          >
            {intervention?.title}
          </Link>
        </div>
      </div>
      {![interventionStatus.CANCELED, interventionStatus.ENDED].includes(
        intervention?.status,
      ) && (
        <div className="w-full border-t border-solid border-[#E2E2E2] grid grid-cols-3 ">
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            href={`tel:${client?.phone}`}
            className="flex items-center justify-center gap-2 p-3 text-[#0022AA] font-semibold text-xl hover:text-[#0022AA] hover:bg-[#f5f7fa]"
          >
            <i className="fi fi-rr-phone-call flex items-center"></i>
            <span className="text-base hidden sm:inline-block">Appel</span>
          </a>
          <Link
            onClick={(e) => {
              e.stopPropagation();
            }}
            to={`/messages#${chatroom?.id}`}
            className=" border-l border-solid border-[#E2E2E2] flex items-center justify-center gap-2 p-3 text-[#FF6600] hover:bg-[#f5f7fa] font-semibold text-xl"
          >
            <i className="fi fi-rr-comment-dots flex items-center"></i>
            <span className="text-base hidden sm:inline-block">Messages</span>
          </Link>
          <a
            onClick={(e) => {
              e.stopPropagation();
            }}
            target="_blank"
            rel="noopener noreferrer"
            href={`http://maps.google.com/?q=${Offer_Proposal?.address} ${Offer_Proposal?.city} ${Offer_Proposal?.zipCode}`}
            className=" border-l border-solid border-[#E2E2E2] flex items-center justify-center gap-2 p-3 text-[#1A64B9] font-semibold text-xl hover:text-[#1A64B9] hover:bg-[#f5f7fa] "
          >
            <i className="fi fi-rr-land-location flex items-center"></i>{" "}
            <span className="text-base hidden sm:inline-block">Itinéraire</span>
          </a>
        </div>
      )}
    </div>
  );
};

export const InterventionCardClient = ({intervention, categories}) => {
  const subCatgegory = intervention?.Offer_Proposal?.Offer?.SubCategories[0];
  const category = categories?.find((el) => el.id == subCatgegory?.fatherId);

  const chatroomId = !intervention?.Offer_Proposal?.Offer
    ? intervention?.Offer_Proposal?.directChat?.chatroomId
    : intervention?.Offer_Proposal?.Offer?.indirectChats?.find(
        (el) =>
          el?.chatroom?.technicianId ===
          intervention?.Offer_Proposal?.technicianId,
      )?.chatroomId;

  const navigate = useNavigate();
  const {bg, color} = getInterventionStatusColor({
    status: intervention?.status,
  });
  const statusLabel = getInterventionStatusLabel(intervention);

  return (
    <div
      className="w-full  flex flex-col overflow-hidden bg-white relative rounded-2xl border border-solid border-[#E2E2E2] cursor-pointer "
      onClick={() => {
        navigate(getInterventionPath(intervention));
      }}
    >
      <div
        style={{
          backgroundColor: bg,
          color: color,
        }}
        className={` absolute right-3 top-3 flex justify-center gap-1 items-center rounded-3xl px-2 leading-6 text-sm font-semibold min-w-[90px] z-10 `}
      >
        <div
          style={{
            backgroundColor: color,
          }}
          className={`w-2 h-2 rounded-full `}
        ></div>
        <span className="text-nowrap">{statusLabel}</span>
      </div>
      <div
        className={`w-full sm:!p-6 !px-3 !py-7 flex flex-col sm:flex-row gap-2   
        `}
      >
        <div className="flex flex-col flex-grow ">
          <div className="flex items-center justify-start  gap-3 ">
            <div className="relative min-w-7 w-7">
              <Link
                to={
                  "/prestataire/" +
                  intervention?.Offer_Proposal?.Technician?.id +
                  "/#avis"
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="bg-[#FFC107] w-5 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[4px] absolute bottom-0 rounded-full left-[50%] -translate-x-[50%] "
              >
                {Number(
                  intervention?.Offer_Proposal?.Technician?.User?.avgRating,
                ).toFixed(2)}
                <StarIcon className="fill-white stroke-none w-1 h-1" />
              </Link>
              <Link
                to={
                  "/prestataire/" + intervention?.Offer_Proposal?.Technician?.id
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
              >
                <ImageComponent
                  src={buildImageUrl(
                    intervention?.Offer_Proposal?.Technician?.User?.imageUri,
                  )}
                  alt=""
                  className=" w-7 aspect-square min-w-7 rounded-full object-cover"
                  fallback={
                    <img
                      src={NoProfile}
                      alt=""
                      className=" w-7 aspect-square min-w-7 rounded-full object-cover"
                      width="130"
                    />
                  }
                />
              </Link>
            </div>
            <div className="flex flex-col justify-center items-start">
              <Link
                to={
                  "/prestataire/" + intervention?.Offer_Proposal?.Technician?.id
                }
                onClick={(e) => {
                  e.stopPropagation();
                }}
                className="text-[#19295C] font-bold text-base capitalize"
              >
                {intervention?.Offer_Proposal?.Technician?.User?.lastName +
                  " " +
                  intervention?.Offer_Proposal?.Technician?.User?.firstName}
              </Link>
            </div>
          </div>

          <div className="text-lg flex items-center justify-start flex-wrap gap-x-3  gap-y-1  font-medium mt-2  w-full ">
            <Link
              title={intervention?.title}
              to={getInterventionPath(intervention)}
              className="text-[#19295C]  font-semibold text-base  capitalize-first  !text-wrap  "
            >
              {intervention?.title}
            </Link>
            <div className="flex items-center ">
              <div className="text-[#FF6600] text-base text-nowrap  ">
                <i className="fi fi-rr-coins flex items-center"></i>
              </div>
              <div className=" text-[#FF6600] ml-1 font-semibold text-sm sm:text-[16px] flex items-center gap-1 text-nowrap ">
                {intervention?.Offer_Proposal?.initialBudget}€
                {!!intervention?.additionalPrice && (
                  <>
                    <span>+{intervention?.additionalPrice}€</span>
                    <span className="text-xs">(frais supplémentaire)</span>
                  </>
                )}
              </div>
            </div>
          </div>
          <div className="flex items-center justify-start gap-1 flex-wrap mt-1 ">
            <div className="text-[#FF6600] text-base text-nowrap ">
              <i className="fi fi-rr-calendar-clock flex items-center"></i>
            </div>
            <div className="text-[14px] leading-4 text-[#7E7E7E]">
              {proposalDate(intervention?.startDate)}
            </div>
          </div>
        </div>

        <div className="flex  sm:flex-col sm:mr-3 items-end  justify-center gap-4 w-full sm:w-auto">
          {![interventionStatus.CANCELED, interventionStatus.ENDED].includes(
            intervention?.status,
          ) &&
            (!intervention?.ended_byTech ? (
              <div className="flex items-center justify-end gap-2  w-full mr-3">
                <Link
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="w-1/2"
                  to={`/messages#${chatroomId ?? ""}`}
                >
                  <button className="font-bold px-[15px] py-[12px] text-base w-full  !rounded-lg bg-white !text-[#1A64B9] !border-[#1A64B9] !border border-solid flex gap-2 justify-center items-center">
                    <i className="fi fi-rr-comment-dots flex items-center"></i>
                    <span className="text-xs">Message</span>
                  </button>
                </Link>
                <a
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  className="w-1/2"
                  href={`tel:${intervention?.Offer_Proposal?.Technician?.User?.phone}`}
                >
                  <button className="font-bold px-[15px] py-[12px] text-base w-full !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next flex gap-2 justify-center items-center">
                    <i className="fi fi-rr-phone-call flex items-center"></i>
                    <span className="text-xs">Appel</span>
                  </button>
                </a>
              </div>
            ) : (
              <Link className="w-full" to={getInterventionPath(intervention)}>
                <button className="font-bold px-[30px] py-[12px] text-base min-w-[100px] w-full  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white  flex gap-2 justify-center items-center">
                  <span className="text-xs">
                    {!!intervention?.additionalPrice ? "Payer" : "Finaliser"}
                  </span>
                </button>
              </Link>
            ))}
        </div>
      </div>
    </div>
  );
};
